import React from "react";
import "../../feature-module/mainMenu/Dashboard/filters/dashboardFilters.css";

export interface FilterChipItem {
  key: string;
  icon: string;
  label: string;
  value: string;
  isDefault?: boolean;
  onRemove?: () => void;
}

interface FilterChipsProps {
  chips: FilterChipItem[];
  onClearAll?: () => void;
  disabled?: boolean;
  className?: string;
}

const MAX_VALUE_LENGTH = 32;

const FilterChips: React.FC<FilterChipsProps> = ({
  chips,
  onClearAll,
  disabled = false,
  className = "mb-4",
}) => {
  if (!chips.length) return null;

  const hasRemovableChips = chips.some((chip) => chip.onRemove);

  return (
    <div
      className={`db-filter-summary d-flex align-items-center flex-wrap gap-2 ${className}`}
    >
      {chips.map((chip) => {
        const isTruncated = chip.value.length > MAX_VALUE_LENGTH;
        return (
          <span
            key={chip.key}
            className={`db-filter-chip ${
              chip.isDefault ? "db-filter-chip-default" : "db-filter-chip-active"
            }`}
            title={
              chip.isDefault
                ? "Default filter"
                : isTruncated
                  ? `${chip.label}: ${chip.value}`
                  : undefined
            }
          >
            <i className={`${chip.icon} db-filter-chip-icon`} />
            <span className="db-filter-chip-label">{chip.label}</span>
            <span className="db-filter-chip-value">
              {isTruncated
                ? `${chip.value.slice(0, MAX_VALUE_LENGTH)}...`
                : chip.value}
            </span>
            {chip.onRemove && (
              <button
                type="button"
                aria-label={`Remove ${chip.label} filter`}
                onClick={chip.onRemove}
                disabled={disabled}
              >
                <i className="ti ti-x" />
              </button>
            )}
          </span>
        );
      })}
      {onClearAll && hasRemovableChips && (
        <button
          type="button"
          className="btn btn-link btn-sm p-0 db-filter-clear"
          onClick={onClearAll}
          disabled={disabled}
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default FilterChips;
